import { useMutation, useQuery } from "react-query";
import URL from "core/resources/urls";
import http from "infra/http";
import qs from "qs";
import { useFilters } from "core/features/filters/store";
import useFiltro from "../hooks/useFiltro";
import { OrderServiceTalhoesList } from "../interfaces/Talhao";

export function useTalhoesPlanejamento() {
  const { filters: { safra, unidade, filtersAdvanced, tabBarSessaoPlanejamentoOperacional } } = useFilters();

  const idUnidade = unidade?.id;
  const safraId = safra?.id;

  return useQuery(
    [URL.PLANO_OPERACIONAL.OBTER_MAPA, idUnidade, filtersAdvanced?.safraPeriodo],
    async () => {
      const body = {
        safraPeriodos: [filtersAdvanced?.safraPeriodo]
      }
      const response = await http.post(
        URL.PLANO_OPERACIONAL.OBTER_MAPA(idUnidade!),
        { ...body },
        {
          params: {
            safraId,
          },
        },
      );

      return response?.data;
    },
    {
      keepPreviousData: true,
      enabled: !!idUnidade && !!filtersAdvanced?.safraPeriodo && tabBarSessaoPlanejamentoOperacional === 'cadastros',
    }
  );
}

export function useTalhoesMap() {
  const { filters: { safra, unidade, menuName, menuNameRelatorios, tabBarSessaoPlanejamentoOperacional } } = useFilters();
  const { filtroExecucaoOPeracional } = useFiltro();

  const filtroOperacional = filtroExecucaoOPeracional as any;

  const idUnidade = unidade?.id;
  const safraId = safra?.id;

  const hasFiltroExecucao =
    filtroExecucaoOPeracional &&
    Object.keys(filtroExecucaoOPeracional).length > 0;

  const newPayload: any = {
    ...filtroExecucaoOPeracional,
  }

  return useQuery(
    [URL.PLANO_OPERACIONAL.OBTER_MAPA, idUnidade, filtroExecucaoOPeracional],
    async () => {
      const response = await http.post(
        URL.PLANO_OPERACIONAL.OBTER_MAPA(idUnidade!),
        { ...newPayload },
        {
          params: {
            safraId,
          },
        },
      );

      return response?.data;
    },
    {
      keepPreviousData: true,
      enabled:
        !!idUnidade &&
        hasFiltroExecucao &&
        (menuName === "Mapa Cronograma" || menuName === "Mapa Semáforo" ||(tabBarSessaoPlanejamentoOperacional === 'relatorios' && menuNameRelatorios === "Relatório de Aderência Operacional")) &&
        !filtroOperacional?.safraPeriodos?.some((s: string) => s === ""),
    }
  );
}

export function useTalhoesMapOS() {
  const { filters: { safra, unidade, menuName, tabBarSessaoPlanejamentoOperacional } } = useFilters();
  const { filtroExecucaoOPeracional } = useFiltro();

  const idUnidade = unidade?.id;
  const safraId = safra?.id;

  const newPayload: any = filtroExecucaoOPeracional;

  const hasFiltroExecucao =
    filtroExecucaoOPeracional &&
    Object.keys(filtroExecucaoOPeracional).length > 0;

  if (menuName === 'Gestão de O.S.') {
    delete newPayload?.statusSemaforo;
    delete newPayload?.datasProgramadas;
  }

  if (newPayload?.operacaoClasses?.length === 0) {
    delete newPayload.operacaoClasses;
  }

  return useQuery(
    [URL.PLANO_OPERACIONAL.OBTER_MAPA_ORDEM_SERVICO, idUnidade, safraId, newPayload],
    async () => {
      
      const response = await http.post(
        URL.PLANO_OPERACIONAL.OBTER_MAPA_ORDEM_SERVICO(idUnidade!),
        { ...newPayload },
        {
          params: {
            safraId,
          },
        },
      );

      return response?.data;
    },
    {
      keepPreviousData: true,
      enabled: !!idUnidade && hasFiltroExecucao && menuName === "Gestão de O.S." && tabBarSessaoPlanejamentoOperacional !== "relatorios",
    }
  );
}


export type OrderServiceTalhoesResponse = OrderServiceTalhoesList[];

export function useOrderServiceTalhoes(filters: any) {
  return useQuery(
    [URL.ORDEM_SERVICO.TALHOES, filters],
    async () => {
      const { data } = await http.get<OrderServiceTalhoesResponse>(URL.ORDEM_SERVICO.TALHOES, {
        params: filters,
        paramsSerializer: (params) =>
          qs.stringify(params, { indices: false }),
      });

      return data;
    },
    {
      keepPreviousData: true,
      enabled: !!filters?.UnidadeId && !!filters?.SafraPeriodoId && !!filters?.TalhaoIds?.length,
    }
  );
}

export function useUpdateVincularTalhoes() {
  return useMutation(async ({ body }: { body: any }) => {
    const response = await http.put(URL.ORDEM_SERVICO.VINCULAR_TALHOES, body);
    return response;
  });
}